import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home/home.component';
import { UserModule } from './user/user.module';
import { ModelloCompagniaComponent } from './anagrafiche/modello-compagnia/modello-compagnia.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home',
  },
  {
    path: 'user',
    loadChildren: () => import(`./user/user.module`).then(m => m.UserModule),
    data: { title: "Pagina Utente" }
  },
  {
    
    path: 'cga-modelli-compagnie', loadChildren: () => import('./anagrafiche/modello-compagnia/modello-compagnia.module').then(m => m.ModelloCompagniaModule),
    data: { title: 'CGA' },
    //path: 'cga-modelli-compagnie',
    //component: ModelloCompagniaComponent,
  },
  {
    path: 'admin', loadChildren: () => import(`./admin/admin.module`).then(m => m.AdminModule),
    data: { title: "Pannello Admin" }
  },
  {
    path: 'incarichi', loadChildren: () => import('./incarichi/incarichi.module').then(m => m.IncarichiModule),
    data: { title: 'Incarichi' },
  },
  {
    path: 'compagnie', loadChildren: () => import('./anagrafiche/compagnie/compagnie.module').then(m => m.CompagnieModule),
    data: { title: 'Compagnie' },
  },
  {
    path: 'agenzie', loadChildren: () => import('./anagrafiche/agenzie/agenzie.module').then(m => m.AgenzieModule),
    data: { title: 'Agenzie' },
  },

  {
    path: 'polizze', loadChildren: () => import('./anagrafiche/polizze/polizze.module').then(m => m.PolizzeModule),
    data: { title: 'Polizze' },
  },
  {
    path: 'ispettorati', loadChildren: () => import('./anagrafiche/ispettorati/ispettorati.module').then(m => m.IspettoratiModule),
    data: { title: 'Ispettorati' },
  },
  {
    path: 'fabbricati', loadChildren: () => import('./anagrafiche/fabbricati/fabbricati.module').then(m => m.FabbricatiModule),
    data: { title: 'Fabbricati' },
  },
  {
    path: 'altri-soggetti', loadChildren: () => import('./anagrafiche/altri-soggetti/altri-soggetti.module').then(m => m.AltriSoggettiModule),
    data: { title: 'Altri Soggetti' },
  },
  {
    path: 'statistiche', loadChildren: () => import('./statistiche/statistiche.module').then(m => m.StatisticheModule),
    data: { title: 'Statistiche' },
  },

  {
    path: 'pagamenti', loadChildren: () => import('./pagamenti/pagamenti.module').then(m => m.PagamentiModule),
    data: { title: 'Pagamenti' },
  },
  { path: 'modulo-riparazione', loadChildren: () => import('./incarichi/view/modulo-riparazione/modulo-riparazione.module').then(m => m.ModuloRiparazioneModule) },
  { path: 'modulo-contatto', loadChildren: () => import('./incarichi/view/modulo-contatto/modulo-contatto.module').then(m => m.ModuloContattoModule) },
  { path: 'perizia-universale', loadChildren: () => import('./incarichi/view/perizia-universale/perizia-universale.module').then(m => m.PeriziaUniversaleModule) },
  { path: 'modello_compagnia', loadChildren: () => import('./anagrafiche/modello-compagnia/modello-compagnia.module').then(m => m.ModelloCompagniaModule) },
  {
    path: 'tickets', loadChildren: () => import('./tickets/tickets.module').then(m => m.TicketsModule),
    data: { title: 'Tickets' },
  },
  {
    path: '**', component: HomeComponent,
    data: { title: "Home" }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes),],
  exports: [RouterModule]
})
export class AppRoutingModule { }
